import React from 'react'
import { PaddedContainer, Heading, FlexContainer, ParaText, IconContainer, Button } from '../../styles/Global.styles'
import { TechStackCard, ProjectImageContainer, ProjectImage } from '../../styles/Projects.styles'
import { FaGithub } from 'react-icons/fa'
import { useMediaQuery } from 'react-responsive'
import { motion } from 'framer-motion'
import { Theme } from '../../utils/Theme'
import { fadeInLeft, fadeInRight } from '../../utils/MotionVariants'

const Project = ( {project, index} ) => {
  const reverse = index % 2 !== 0
  const isMobile = useMediaQuery({ maxWidth: Theme.breakpoints.mobile })

  return (
    <FlexContainer
        fullWidthChild
        direction={reverse ? "row-reverse" : false}
        align={isMobile && "center"}
    >
        <motion.div
            variants={reverse ? fadeInRight : fadeInLeft}
            initial="hidden"
            whileInView="visible"
        >
            <FlexContainer align="center" gap="1rem">
                <Heading
                    as="h3"
                    size="h3"
                    bottom="1rem"
                >
                    {project.name}
                </Heading>
                <IconContainer color="blue" size="2rem">
                    {project.open_source && <FaGithub />}
                </IconContainer>
            </FlexContainer>

            <PaddedContainer top="1rem">
                <FlexContainer gap="1rem">
                    {project.tech_stack.map((tech) => (
                        <TechStackCard key={tech}>{tech}</TechStackCard>
                    ))}
                </FlexContainer>
            </PaddedContainer>

            <ParaText top="1.5rem" bottom="2rem">
                {project.description}
            </ParaText>

            <Button href={project.url} target="_blank">View {project.open_source ? "Code" : "Live"}</Button>
        </motion.div>
        <ProjectImageContainer
            as={motion.div}
            variants={reverse ? fadeInLeft : fadeInRight}
            initial="hidden"
            whileInView="visible"
            justify={reverse ? "flex-start" : "flex-end"}
        >
            <ProjectImage src={project.image} alt={project.name} />
        </ProjectImageContainer>
    </FlexContainer>
  )
}

export default Project
